import List from '../../../components/List';
import Button from '../../../components/Button';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectProduct } from '../../../../../../store/selectors/products';
import { useHistory } from 'react-router-dom';
import { slugify } from '../../../Products/helpers';

const Links = () => {
  const history = useHistory();
  const { data } = useSelector(selectProduct);
  const {
    content: { title },
  } = data;

  const handleRedirect = useCallback(
    (environment) => () =>
      environment === 'test'
        ? history.push(`/integrations/${slugify(title)}/permissions/testing`)
        : history.push(`/integrations/${slugify(title)}/permissions/production`),
    []
  );

  return (
    <div>
      <List direction='row'>
        <Button type='secondary' label='Test environment' onCallback={handleRedirect('test')} />

        <div style={{ width: 12 }} />

        <Button type='secondary' label='Production environment' onCallback={handleRedirect('production')} />
      </List>
    </div>
  );
};

export default Links;
